import { Suspense, type FunctionComponent } from 'react';

// oxlint-disable-next-line no-restricted-imports
import type { LogoProps } from '@atlaskit/logo';
import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyJiraLogo: FunctionComponent<LogoProps> = (props) => {
  const JiraLogo = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlaskit-logo-jira" */ '@atlaskit/logo/jira/logo'
      ),
    { namedImport: 'JiraLogoCS' },
  );

  return (
    <ErrorBoundary tags={{ ownershipArea: 'trello-web-eng' }}>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <JiraLogo {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
